'use client';

import { c as _c } from "react/compiler-runtime";
import type { MotionProps } from 'motion/react';
import { AnimatePresence, LazyMotion, m } from 'motion/react';
import { useTopNav } from '@src/components/TopNavV3/TopNavContext';
import { TopNavMobileMenu } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileMenu';
import { TopNavMobileSubMenu } from '@src/components/TopNavV3/TopNavMobile/TopNavMobileSubMenu';
const loadFramerMotionFeatures = async () => await import('./framerMotionFeatures').then(res => res.framerMotionFeatures);
export const TopNavMobileSlidingPanel = t0 => {
  const $ = _c(21);
  const {
    navBox
  } = t0;
  const {
    isExpanded,
    isMobileSubExpanded
  } = useTopNav();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: "spring",
      duration: 0.3,
      bounce: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const transition = t1 satisfies MotionProps['transition'];
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      open: {
        x: "0"
      },
      closed: {
        x: "-100%"
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isExpanded ? isMobileSubExpanded ? "closed" : "open" : "closed";
  let t4;
  if ($[2] !== t3) {
    t4 = {
      variants: t2,
      initial: "closed",
      animate: t3,
      exit: "closed",
      transition
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const menuProps = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      closedRight: {
        x: "100%"
      },
      closedLeft: {
        x: "-100%"
      },
      open: {
        x: "0"
      }
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isMobileSubExpanded ? isExpanded ? "open" : "closedLeft" : "closedRight";
  const t7 = isExpanded ? "closedRight" : "closedLeft";
  let t8;
  if ($[5] !== t6 || $[6] !== t7) {
    t8 = {
      variants: t5,
      initial: "closedRight",
      animate: t6,
      exit: t7,
      transition
    };
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const subMenuProps = t8 satisfies MotionProps;
  let t9;
  if ($[8] !== navBox) {
    t9 = !navBox ? undefined : {
      top: `${navBox.height}px`,
      height: `calc(100dvh - ${navBox.top}px - ${navBox.height}px)`
    };
    $[8] = navBox;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const style = t9;
  let t10;
  if ($[10] !== isExpanded || $[11] !== menuProps || $[12] !== style) {
    t10 = isExpanded && <m.aside key="menu" className="absolute z-50 overflow-y-scroll left-0 w-full bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 text-white" {...menuProps} style={style}><TopNavMobileMenu /></m.aside>;
    $[10] = isExpanded;
    $[11] = menuProps;
    $[12] = style;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isMobileSubExpanded || $[15] !== style || $[16] !== subMenuProps) {
    t11 = isMobileSubExpanded && <m.aside key="submenu" className="absolute z-50 overflow-y-scroll left-0 w-full bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 text-white" {...subMenuProps} style={style}><TopNavMobileSubMenu /></m.aside>;
    $[14] = isMobileSubExpanded;
    $[15] = style;
    $[16] = subMenuProps;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <LazyMotion features={loadFramerMotionFeatures}><AnimatePresence>{t10}{t11}</AnimatePresence></LazyMotion>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};